import dayjs from 'dayjs'
import {
    INVENTORY_RATECALENDAR,
    INVENTORY_RATECALENDAR_REFRESH,
    INVENTORY_RATECALENDAR_SUCCESS,
    INVENTORY_RATECALENDAR_FAIL,
    INVENTORY_RATECALENDAR_UPDATE,
    INVENTORY_RATECALENDAR_UPDATE_FAIL,
    INVENTORY_RATECALENDAR_UPDATE_SUCCESS,
    INVENTORY_BULKUPDATE_REQUEST,
    INVENTORY_BULKUPDATE_SUCCESS,
    INVENTORY_BULKUPDATE_FAIL,
    INVENTORY_BULKUPDATE_RESET
} from 'constants/ActionTypes'

export const bulkUpdateReset = () => {
    return {
        type: INVENTORY_BULKUPDATE_RESET
    }
}
export const bulkUpdateSuccess = (value) => {
    return {
        type: INVENTORY_BULKUPDATE_SUCCESS,
        payload: value
    }
}
export const bulkUpdateFail = (value) => {
    return {
        type: INVENTORY_BULKUPDATE_FAIL,
        payload: value
    }
}
export const bulkUpdateRequest = (value) => {
    return {
        type: INVENTORY_BULKUPDATE_REQUEST,
        payload: value
    }
}

export const updateInventoryCalendarSuccess = (data) => {
    return {
        type: INVENTORY_RATECALENDAR_UPDATE_SUCCESS,
        payload: data
    }
}

export const updateInventoryCalendar = (start_date, value, processUpdateMSG, silent = false) => {
    if(value.length<=0) {
        // getInventoryRateCalendar(start_date)
        return {
            type: INVENTORY_RATECALENDAR,
            start_date: start_date,
            is_edit_data: false
          }
    }
    return {
        type: INVENTORY_RATECALENDAR_UPDATE,
        start_date,
        payload: value,
        processUpdateMSG: processUpdateMSG,
        silent
    }
}

export const updateInventoryCalendarFail = (messages) => {
    return {
        type: INVENTORY_RATECALENDAR_UPDATE_FAIL,
        processUpdateMSG: messages
    }
}

// Number of days shown per page of the rate calendar (also drives forward/backward paging)
export const INVENTORY_NUMBER_OF_DAYS = 15

const chooseStartdate = (period, todaySystemDate, value) => {
    switch (period) {
        case 'today':
            return dayjs(value).format('YYYY-MM-DD')
        case 'nextMonth':
            return dayjs(value).add(1, 'months').format('YYYY-MM-DD')
        case 'forward':
            return dayjs(value).add(INVENTORY_NUMBER_OF_DAYS, 'days').format('YYYY-MM-DD')
        case 'backward':
            const startDays = dayjs(value).subtract(INVENTORY_NUMBER_OF_DAYS, 'days').format('YYYY-MM-DD')
            if(dayjs(startDays).diff(todaySystemDate, 'days')<=0) return dayjs(todaySystemDate).format('YYYY-MM-DD')
            return startDays
        case 'previousMonth':
            const startMonths = dayjs(value).subtract(1, 'months').format('YYYY-MM-DD')
            if(dayjs(startMonths).diff(todaySystemDate, 'months')<=0) return dayjs(todaySystemDate).format('YYYY-MM-DD')
            return startMonths
        case 'calendar':
            return dayjs(value).format('YYYY-MM-DD')
        default:
            return dayjs(value).format('YYYY-MM-DD')
    }
}
export const chooseInventoryRateCalendar = (period, todaySystemDate, value, is_edit_data = false) => {
    return {
      type: INVENTORY_RATECALENDAR,
      start_date: chooseStartdate(period, todaySystemDate, value),
      is_edit_data: is_edit_data
    }
}
export const getInventoryRateCalendar = (start_date, is_edit_data = false) => {
    return {
      type: INVENTORY_RATECALENDAR,
      start_date: start_date,
      is_edit_data: is_edit_data
    }
}

// Background refresh after an instant save (switch toggle / range edit):
// same fetch as getInventoryRateCalendar but WITHOUT clearing dataSource or
// raising the loader, so only the changed cells visually update.
export const refreshInventoryRateCalendar = (start_date) => {
    return {
      type: INVENTORY_RATECALENDAR_REFRESH,
      start_date: start_date,
      is_edit_data: false
    }
}

export const getInventoryRateCalendarSuccess = (data) => {
    return {
        type: INVENTORY_RATECALENDAR_SUCCESS,
        payload: data
    }
}

export const getInventoryRateCalendarFail = (messages) => {
    return {
        type: INVENTORY_RATECALENDAR_FAIL,
        messages: messages
    }
}